import * as React from "react";
import { Component } from "react";
import CancelableAxiosInstance from "../../../api/CancelableAxiosInstance";
import { Series } from "../../../api/StudyApi";
import { AuthManager } from "../../auth/AuthContext";
import Img from "../Image";

import ViewportImage from "../ViewportImage";
import ImageResults from "./ImageResults";
import AiPassBadges from "./AiPassBadges";
import ImageTags from "./ImageTags";

interface SeriesProps {
  series: Array<Series>;
  dspImageResults?: boolean;
  images: Array<ViewportImage>;
  dspAiBadge?: boolean;
  underSeries?: { (): JSX.Element };

  onSelectImage(image: ViewportImage): void;

  authManager: AuthManager;
}

export default class SeriesNav extends Component<SeriesProps> {
  private client: CancelableAxiosInstance;

  constructor(props: SeriesProps) {
    super(props);
    this.client = this.props.authManager.cancelableClient();
  }

  componentWillUnmount() {
    this.client.cancelRequests();
  }

  render() {
    return (
      <div className="series">
        {this.props.series?.map((s, idx) => (
          <div key={idx}>
            <p>
              {s.seriesNumber} - {s.modality} - {s.bodyPartExamined}
            </p>

            <div className="image-list">
              {s.images.map((img) => {
                const imgElt = this.props.images?.find((image) => image.id === img.id);

                return (
                  imgElt && (
                    <div
                      key={imgElt.path}
                      className={imgElt.selected ? "img-cont selected" : "img-cont"}
                      onClick={() => this.props.onSelectImage(imgElt)}
                    >
                      <div className="img-tags">
                        <ImageTags viewportImage={imgElt} />
                      </div>

                      <AiPassBadges viewportImage={imgElt} displayAiBadge={this.props.dspAiBadge} />

                      <Img
                        className="img-thumbnail"
                        src={imgElt.image.thumbnailPath}
                        authManager={this.props.authManager}
                      />
                    </div>
                  )
                );
              })}
            </div>
          </div>
        ))}
        {this.props.underSeries?.()}
        {this.props.dspImageResults && (
          <ImageResults
            images={this.props.images}
            authManager={this.props.authManager}
            onSelectImage={this.props.onSelectImage}
          />
        )}
      </div>
    );
  }
}
